import { render, staticRenderFns } from "./ModalListFoliosComponent.vue?vue&type=template&id=801c7d86"
import script from "./ModalListFoliosComponent.vue?vue&type=script&lang=js"
export * from "./ModalListFoliosComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports